import React from 'react'
import styled from 'styled-components'
import system from 'system-components'
import { Box, Link, Flex } from 'components'

const BoxLink = styled(Link)`
  position: relative;
  display: block;
  overflow: hidden;
  box-shadow: 1px 3px 13px -3px rgba(0,0,0,0.3);
  border-radius: 5px;
  transition: transform 0.1s;
  :hover {
    transform: scale(1.05);
  }
`

const RatioBox = styled(system({
  is: Box,
  borderRadius: 0,
  pb: '75%'
}))`
  height: 0px;
  background-size: cover;
  background-position: center;
`

const CenterBox = styled(Box)`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  padding: 10px;
  line-height: 1.5em;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
`

const FillBox = styled(Box)`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  opacity: 0.8;
`

const Wrap = styled(Box)`
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  @media only screen and (min-width: 420px) {
    gap: 25px;
  }
`

export default ({ list=[] }) => (
  <Wrap>
    {list && list.map(item => (
      <Box key={item.id || item.slug} >
        <BoxLink to={`/project/${item.slug}`}>
          <FillBox style={{ background: item.primaryColor || '#ffffff87' }} />
          <RatioBox style={{ backgroundImage: `url('${item.thumbnail || item.image}')` }} />
          <CenterBox style={{ color: item.secondaryColor }}>
            {item.title}
          </CenterBox>
        </BoxLink>
      </Box>
    ))}
  </Wrap>
)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/ProjectList.js